// LIBRARIES
import { Button } from "@mui/material";
import styled from "styled-components";

// MISC
import { COLORS } from "constants/styleVariables";

export const InputUploadContainer = styled.input``;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const ImageContainer = styled.img``;
export const TextContainer = styled.text`
  text-decoration: underline;
  text-decoration-color: ${COLORS.cornflowerBlue};
  color: ${COLORS.cornflowerBlue};
  text-transform: none;
  text-align: center;
`;
export const ButtonContainer = styled(Button)`
  && {
    color: blue;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    width: 282px;
    border: 2px dashed ${COLORS.cornflowerBlue};
    border-bottom: 2px dashed ${COLORS.cornflowerBlue} !important;
    border-radius: 15px;
  }
`;
